/**
 * Shared display helpers for episode sticky notes (EMR-566).
 *
 * Keep Hotbox tooltips and the Episode Notes log on the same clock and date
 * phrasing so a note looks identical wherever it is read.
 */

/** Full timestamp for episode-note metadata (e.g. "Jan 4, 2026, 12:00 PM"). */
export function formatEpisodeNoteTimestamp(createdAt: string): string {
  const date = new Date(createdAt);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  return date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}
